import React from "react";

const ColorPicker = ({
  label,
  colors,
  selectedColor,
  setSelectedColor,
  inputName,
  disabled = false,
}) => {
  return (
    <div className="col-sm-6">
      <p className="py-2 px-3 rounded-md mb-2 border" style={{ backgroundColor: selectedColor }}>
        {label}
      </p>
      <div className="flex flex-wrap gap-2">
        {colors.map((color, i) => {
          const colorValue = color.color || color;
          const colorId = `${inputName}_${color.name || colorValue}`;
          return (
            <span key={i} className="relative">
              <input
                disabled={disabled}
                type="radio"
                name={inputName}
                value={colorValue}
                className="hidden"
                id={colorId}
                onChange={() => setSelectedColor(colorValue)}
                checked={selectedColor === colorValue}
              />
              <label
                htmlFor={colorId}
                className="w-8 h-8 inline-block rounded-full border-2 cursor-pointer transition-all duration-200"
                style={{
                  backgroundColor: colorValue,
                  borderColor: selectedColor === colorValue ? "#000" : "transparent",
                }}
              ></label>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ColorPicker;
